import {Injectable} from '@angular/core';


@Injectable()
export class SearchService {

    public orderSearchByScore(results: {object: any; score: number}[]) {
        results.sort(function(a,b) {
            return b.score - a.score;
        });
        return results.map(function(item) { return item.object;});
    }

}
